import React, { useState } from 'react';
import { useAtom } from 'jotai';
import filterAtom from '../atoms/filterAtom';
import { Button, Form, Select, InputNumber } from 'antd';
import { StyledFilterFields, StyledFilterButtons, StyledForm } from './styled';
import { IFilterOptions } from './types';
import { getMetricsMapping } from '../utils';

const { Option } = Select;

const FilterForm: React.FC<{
  filterOptions: IFilterOptions;
}> = ({ filterOptions }) => {
  const [filter, setFilter] = useAtom(filterAtom);
  const [formItems, setFormItems] = useState<any>(filter);

  const onFinish = (values: any) => {
    setFilter({
      ...formItems,
      ...values,
    });
  };

  const handleReset = () => {
    setFilter({
      cdn: '',
      asn: '',
      dma: '',
      policy: '',
      triggerKpi: '',
      blacklistedKpi: '',
      duration: '',
      referenceKpi: '',
      kpiSampleSize: '',
      blackListCondition: '=',
      durationCondition: '=',
      referenceCondition: '=',
      sampleSizeCondition: '=',
    });
  };

  const selectFilter = (condition) => {
    const handleChange = (value) => {
      setFormItems({ ...filter, [condition]: value });
    };

    return (
      <Select defaultValue={filter[condition]} style={{ width: '60px' }} onChange={handleChange}>
        <Option value="=" title="equal">
          =
        </Option>
        <Option value=">=" title="greater than">{`>=`}</Option>
        <Option value="<=" title="less than">{`<=`}</Option>
      </Select>
    );
  };

  const metricsMapping = getMetricsMapping();

  return (
    <Form
      name="filter-form"
      onFinish={onFinish}
      initialValues={formItems}
      className="resiliency-filter-form"
    >
      <StyledForm>
        <StyledFilterFields>
          <Form.Item name="cdn" label="CDN">
            <Select placeholder="CDN">
              {filterOptions.cdnOptions.map((cdn) => (
                <Option key={cdn.key} value={cdn.key}>
                  {cdn.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="asn" label="ISP">
            <Select placeholder="ISP">
              {filterOptions.asnOptions.map((asn) => {
                return (
                  <Option key={asn.key} value={asn.key}>
                    {asn.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item name="dma" label="DMA">
            <Select placeholder="DMA">
              {filterOptions.dmaOptions.map((dma) => {
                return (
                  <Option key={dma.key} value={dma.key}>
                    {dma.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item name="policy" label="Policy">
            <Select placeholder="Policy">
              {filterOptions.policyOptions.map((policy) => (
                <Option key={policy.key} value={policy.key}>
                  {policy.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="triggerKpi" label="Trigger KPI">
            <Select placeholder="Trigger KPI">
              {filterOptions.triggerKpiOptions.map((triggerKpi) => (
                <Option key={triggerKpi.key} value={triggerKpi.key}>
                  {metricsMapping[triggerKpi.key]}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="blacklistedKpi" label="Blacklisted KPI">
            <InputNumber addonBefore={selectFilter('blackListCondition')} defaultValue="" />
          </Form.Item>

          <Form.Item name="duration" label="Duration">
            <InputNumber addonBefore={selectFilter('durationCondition')} defaultValue="" />
          </Form.Item>

          <Form.Item name="referenceKpi" label="Reference KPI">
            <InputNumber addonBefore={selectFilter('referenceCondition')} defaultValue="" />
          </Form.Item>

          <Form.Item name="kpiSampleSize" label="KPI Sample Size">
            <InputNumber addonBefore={selectFilter('sampleSizeCondition')} defaultValue="" />
          </Form.Item>
        </StyledFilterFields>
        <StyledFilterButtons>
          <Button htmlType="reset" onClick={handleReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </StyledFilterButtons>
      </StyledForm>
    </Form>
  );
};

export default FilterForm;
